import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getFeedbackDetailSlice = createSlice({
  name: "getFeedbackDetail",
  initialState,
  reducers: {
    setArriveLateDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetFeedbackDetailId: (state) => {
      state.id = "";
    },
    getFeedbackDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getFeedbackDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getFeedbackDetailFailed: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    resetFeedbackDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  setArriveLateDetailId,
  resetFeedbackDetailId,
  getFeedbackDetailStart,
  getFeedbackDetailSuccess,
  getFeedbackDetailFailed,
  resetFeedbackDetail,
} = getFeedbackDetailSlice.actions;

export default getFeedbackDetailSlice.reducer;
